import type { Lodging } from "@b2bportal/lodging-api";

import { getPercentOff } from "@/utilities/hotels/discount";

/** Anything at 4% off or less is dropped. */
export const MIN_PERCENT_OFF = 5;

/**
 * Drops lodgings below `MIN_PERCENT_OFF`, then sorts by deepest discount.
 * Stable, so equal discounts keep the incoming popularity order. Returns a new
 * array — the input is the cached availability response.
 */
export const rankOfferLodgings = (lodgings: Lodging[]): Lodging[] =>
  lodgings
    .map((lodging) => ({
      lodging,
      // Matches the rounded number on the card's discount pill.
      percentOff: getPercentOff(
        lodging.price?.totalDiscountAwareTaxesAndFeesIncluded
      ),
    }))
    .filter(({ percentOff }) => percentOff >= MIN_PERCENT_OFF)
    .sort((a, b) => b.percentOff - a.percentOff)
    .map(({ lodging }) => lodging);
